// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"914":"df5f5e81","925":"2307f3ff"}[chunkId] + ".chunk.css";
};